import * as React from "react";
import type { SVGProps } from "react";
const SvgEasyjet = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 50 50"
    width="100%"
    height="100%"
    {...props}
  >
    <path fill="#ff6801" d="M3 3h44v44H3z" />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M37.998 26.104H23.911c-.638 0-.928.29-.928.828q0 1.917 2.09 3.66 2.09 1.755 4.544 1.756c.93 0 2.034-.176 3.196-.524 1.163-.363 2.15-.826 2.904-1.35.697-.465 1.233-.696 1.64-.696.524 0 1.045.29 1.51.928.525.64.756 1.294.756 1.99 0 1.452-.873 2.787-2.673 4.125-3.15 2.395-6.81 3.557-10.949 3.557-4.18 0-7.681-1.22-10.527-3.674a14.5 14.5 0 0 1-3.384-4.297c-1.162-2.281-1.742-4.605-1.742-7.117 0-3.311.987-6.344 3.021-9.017 1.757-2.339 3.964-4.022 6.692-5.184 2.05-.887 4.257-1.294 6.581-1.294 3.789 0 6.982 1.062 9.655 3.211 1.353 1.045 2.398 2.322 3.209 3.847q1.395 2.526 1.396 4.895c0 1.276-.293 2.324-.814 3.193-.582.756-1.28 1.163-2.09 1.163m-13.273-5.592h3.021q1.93 0 1.93-1.742c0-1.045-.29-1.976-.943-2.614-.639-.711-1.394-1.001-2.442-1.001-1.104 0-1.973.465-2.611 1.35-.583.813-.873 1.627-.873 2.497 0 .582.117.99.407 1.279.29.117.756.231 1.51.231"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgEasyjet;
